import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { TosComponent } from './terms-of-service/tos/tos.component';
import { InterpretingResultsComponent } from './interpreting-results/interpreting-results.component';
import { UserGuideComponent } from './user-guide/user-guide.component';
import { GlossaryComponent } from './glossary/glossary.component';
import { RateMethodologyComponent } from './rate-methodology/rate-methodology.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'home',
        component: HomeComponent,
        data: {
          title: 'Home'
        }
      },
      {
        path: 'glossary',
        component: GlossaryComponent,
        data: {
          title: 'Glossary'
        }
      },
      {
        path: 'methodology',
        component: RateMethodologyComponent,
        data: {
          title: 'FMV Hourly Rate Methodology'
        }
      },
      {
        path: 'terms-of-service',
        component: TosComponent,
        data: {
          title: 'Terms of Service'
        }
      },
      {
        path: 'interpreting-results',
        component: InterpretingResultsComponent,
        data: {
          title: 'Interpreting your Results'
        }
      },
      {
        path: 'user-guide',
        component: UserGuideComponent,
        data: {
          title: 'User Guide'
        }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule { }
